import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import './Layout/HorizontalStack';
import './Layout/TwoColumn';
import './Layout/Whitespace';

@customElement('lindberg-layouts')
export class Layouts extends LitElement {
  static styles = css`
    :host, section.grid {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: var(--space-100);
        @media (width >= 1160px) {
            gap: var(--space-200);
        }
        @media (width < 600px) {
            grid-template-columns: repeat(4, 1fr);
        }
    }
    .text-area {        
        outline: 1px dotted deeppink;
        @media (width >= 1160px) {
            grid-column: 4 / span 6;
        }
        
        @media (912px <= width < 1160px) { 
            grid-column: 3 / span 8;    
        }

        @media (600px <= width < 912px) { 
            grid-column: 2 / span 10;
        }

        @media (width < 600px) {
            grid-column: 1 / span 4;
            padding: var(--space-100);
        }
    }

    .text-area.margin {
        outline: 1px dotted deeppink;
        @media (width >= 1160px) {
            padding: var(--space-900);
        }
        
        @media (912px <= width < 1160px) {                 
            padding: var(--space-600);
        }

        @media (600px <= width < 912px) { 
            padding: var(--space-400);
        }

        @media (width < 600px) {
            padding: var(--space-300);
        }
    }
    .usp {
        grid-column: 1 / -1;
        display: flex;

        gap: var(--space-100);
        @media (width >= 1160px) {
            gap: var(--space-200);
        }

        @media (width < 600px) {
            flex-direction: column;
            padding: var(--space-100);
        }
        & > div {
            flex: 1;
            outline: 1px dotted deeppink;
            text-align: center;
        }
    }
    lindberg-horizontal-stack {
        grid-column: 1 / -1;
        & > div {
            /*DEBUG*/
            outline: 1px dotted blue;
            text-align: center;
        }
    }   
    .featured-media {
        grid-column: 1 / -1;
        outline: 1px dotted deeppink;
        & > :first-child {
            background: gray;
            grid-column: 1 / span 8;
            @media (width < 600px) {
                grid-column: 1 / -1;
            }
        }
        & > :nth-child(2) {
            
            grid-row: 2;
            outline: 1px dotted yellowgreen;

            @media (width >= 1160px) {
                grid-column: 5 / span 4;
            }
            
            @media (912px <= width < 1160px) {                 
                grid-column: 3 / span 6;
            }

            @media (600px <= width < 912px) { 
                grid-column: 1 / span 8;
            }

            @media (width < 600px) {
                grid-column: 1 / -1;
                grid-row: 2;
            }
        }
        & > :nth-child(3){
            grid-column: 9 / span 4;
            grid-row: 1 / span 2;
            background: gray;
            align-self: end;
            @media (width < 600px) {
                grid-column: 2 / -1;
                grid-row: 3;
            }
        }      
  `;

  render() {
    return html`
        <lindberg-horizontal-stack>
            <div>
                <h4>groove colours</h4>
                <p>Groove colours allow for great personalisation</p>
            </div>
            <div>
                <h4>hinge design</h4>
                <p>Innovative minimalistic hinge design without any screws or rivets</p> 
            </div>
            <div>
                <h4>rimless appearance</h4>
                <p>Almost rimless in appearance
                – front embedded in the lens</p>
            </div>
            <div>
                <h4>acetate inner rim</h4>
                <p>The collection features designs with acetate inner rims for a stronger appearance</p>
            </div>
        </lindberg-horizontal-stack>
                <lindberg-horizontal-stack>
            <div>
                <h4>groove colours</h4>
                <p>Groove colours allow for great personalisation</p>
            </div>
            <div>
                <h4>hinge design</h4>
                <p>Innovative minimalistic hinge design without any screws or rivets</p> 
            </div>
            <div>
                <h4>rimless appearance</h4>
                <p>Almost rimless in appearance
                – front embedded in the lens</p>
            </div>
        </lindberg-horizontal-stack>

      <section class="text-area">
        Text Area
        <h1>n.o.w. titanium</h1>
        <p>The n.o.w. titanium collection has the perfect balance of expressive look and lightness with our signature elements: thin composite fronts and lightweight titanium temples.</p>
      </section>
      <section class="text-area margin">
        Text Area
        <h1>n.o.w. titanium</h1>
        <p>The n.o.w. titanium collection has the perfect balance of expressive look and lightness with our signature elements: thin composite fronts and lightweight titanium temples.</p>
      </section>
    <lindberg-horizontal-stack>
        <section class="text-area">
        Text Area
        <h1>n.o.w. titanium</h1>
        <p>The n.o.w. titanium collection has the perfect balance of expressive look and lightness with our signature elements: thin composite fronts and lightweight titanium temples.</p>
      </section><section class="text-area">
        Text Area
        <h1>n.o.w. titanium</h1>
        <p>The n.o.w. titanium collection has the perfect balance of expressive look and lightness with our signature elements: thin composite fronts and lightweight titanium temples.</p>
      </section>
    </lindberg-horizontal-stack>

    <lindberg-horizontal-stack>
        <div>1 / 3</div>
        <div>2 / 3</div>
        <div>3 / 3</div>
    </lindberg-horizontal-stack>

    <lindberg-horizontal-stack>
        <div>1 / 5</div>
        <div>2 / 5</div>
        <div>3 / 5</div>
        <div>4 / 5</div>
        <div>5 / 5</div>
    </lindberg-horizontal-stack>

    <lindberg-horizontal-stack>
        <div>1 / 6</div>
        <div>2 / 6</div>
        <div>3 / 6</div>
        <div>4 / 6</div>
        <div>5 / 6</div>
        <div>6 / 6</div>
    </lindberg-horizontal-stack>

      <section class="grid featured-media">
        <div style="aspect-ratio: 435/435;">IMG1</div>
        <div>
            <h3>header</h3>
            <p>The various multi-adjustable temple designs for the n.o.w. titanium collection are made of our signature high-quality titanium. This provides an elegant, minimalist contrast to the front and ensures maximum comfort.</p>
        </div>
        <div style="aspect-ratio: 34/47;">IMG2</div>
      </section>

    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-layout': Layouts;
  }
}
